@if (standaloneItems.length) {
  <div class="space-y-4">
    @for (item of standaloneItems; track $index) {
      <div
        class="appointment-summary-item"
        [class.cursor-pointer]="canInteractWithItems"
        [class.pointer-events-none]="!canInteractWithItems"
        (click)="onSelectItem(item.serviceItemId)"
      >
        <div class="flex items-center">
          <div nz-typography class="grow me-2 font-semibold">
            {{ item.serviceName }}
          </div>
          <div class="flex items-center shrink-0">
            @if (showPrices) {
              <div nz-typography>{{ getTotalPriceForItem(item) | customCurrency: appointment?.currency }}</div>
            }
            @if (showDeleteActions) {
              <div
                (click)="onDeleteItem(item, $event)"
                class="cursor-pointer"
                [class.pointer-events-none]="!canInteractWithItems"
                [class.opacity-50]="!canInteractWithItems"
                [attr.title]="'shared.buttons.delete' | translate"
                [attr.aria-disabled]="!canInteractWithItems"
              >
                <span nz-icon nzType="close" nzTheme="outline" class="!text-neutral-600 p-2 -me-3 text-sm"></span>
              </div>
            }
          </div>
        </div>
        @if (item.choiceId) {
          <div nz-typography class="grow">{{ item.choiceName }}</div>
        }
        @for (addon of getAddonsForItem(item); track $index) {
          <div nz-typography class="grow">{{ addon.serviceName }}</div>
        }
        <div nz-typography class="grow">
          {{ getExpertDetails(item.expertId).displayName || getExpertDetails(item.expertId).firstName }} &middot;
          {{ getTotalDurationForItem(item) | customTime }}
        </div>
      </div>
    }
  </div>

  @if (showPrices) {
    <nz-divider class="my-0"></nz-divider>
    <div [class.me-4]="showDeleteActions">
      <div class="flex">
        <div nz-typography class="grow">{{ 'components.cart-content.label-subtotal' | translate }}</div>
        <div nz-typography>{{ appointment?.servicesTotal | customCurrency: appointment?.currency }}</div>
      </div>

      @if (appointment?.discount) {
        <div class="flex">
          <div nz-typography class="grow">{{ 'components.cart-content.label-discount' | translate }}</div>
          <div nz-typography>-{{ appointment?.discount | customCurrency: appointment?.currency }}</div>
        </div>
      }

      @if (appointment?.absorbFee === false && appointment?.bookingFee) {
        <div class="flex mt-1">
          <div nz-typography class="grow">
            {{ 'components.cart-content.label-booking-fee' | translate }} ({{ appointment?.bookingFee }}%)
          </div>
          <div nz-typography>{{ appointment?.bookingFeeAmount | customCurrency: appointment?.currency }}</div>
        </div>
      }

      @if (showRemainingAmount) {
        <div class="flex mt-4">
          <div nz-typography class="grow">{{ 'components.cart-content.label-amount-paid' | translate }}</div>
          <div nz-typography>
            {{
              (appointment?.prePaidAmount ? '-' : '') +
                (appointment?.prePaidAmount || 0 | customCurrency: appointment?.currency)
            }}
          </div>
        </div>
        <div class="flex">
          <div nz-typography class="grow">
            <strong>{{ 'components.cart-content.label-remaining-to-pay' | translate }}</strong>
          </div>
          <div nz-typography>
            <strong>{{ remainingAmount | customCurrency: appointment?.currency }}</strong>
          </div>
        </div>
      } @else {
        <div class="flex mt-4">
          <div nz-typography class="grow">
            <strong>{{ 'components.cart-content.label-total-price' | translate }}</strong>
          </div>
          <div nz-typography>
            <strong>{{ appointment?.totalPrice | customCurrency: appointment?.currency }}</strong>
          </div>
        </div>
      }
    </div>
  }
}
